export { default } from './AppText';
